import { render, staticRenderFns } from "./luxeInLisbon.vue?vue&type=template&id=15741abd&scoped=true&"
import script from "./luxeInLisbon.vue?vue&type=script&lang=js&"
export * from "./luxeInLisbon.vue?vue&type=script&lang=js&"
import style0 from "./luxeInLisbon.vue?vue&type=style&index=0&id=15741abd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15741abd",
  null
  
)

export default component.exports